import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Input from "../../../../components/common/inputs/Input";
import Button from "../../../../components/common/button/Button";
import Table from "../../../../components/common/table/Table";
import { featureValidation } from "../../../../utils/validations/prodcut/featureValidation";
import { warningMessage } from "../../../../utils/toastify-message/ToastifyMessage";
import { featuresColumns } from "../../../../constant/tablesColumns/tablesColums";

const { forwardRef, useRef, useImperativeHandle } = React;

const ProductFeature = forwardRef(({ featureData, handleFeatures }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {
      setFeatures([]);
      setFeature(null);
    },
  }));

  console.log(featureData);

  const [feature, setFeature] = useState(null);
  const [features, setFeatures] = useState([]);

  const formHandler = async (values, { resetForm }) => {
    let isExist = features.filter((item) => {
      return item.title == values.title;
    });
    if (!isExist.length) {
      setFeatures((prev) => [...prev, values]);
      setFeature(null);
      resetForm();
    } else {
      warningMessage("این مقدار از قبل موجود است.");
    }
  };

  const onDelete = (data) => {
    const newFeatures = features.filter((item) => item.title != data.title);
    setFeatures(newFeatures);
  };

  const onEdit = (data) => {
    setFeature(data);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleNewFeature = () => {
    handleFeatures(features);
    setShowModal(false);
  };

  useEffect(() => {
    if (featureData.length) {
      setFeatures(featureData);
    }
  }, [featureData]);

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full transition-all z-30  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-full h-full overflow-y-scroll  bg-white dark:bg-gray-900 shadow-md z-40 rounded-3xl p-4 transition-all absolute top-0 -left-[120%] ${
          showModal && "!left-0"
        }`}
      >
        <div className="flex w-full items-center justify-between">
          <h4 className=" dark:text-white">اضافه کردن ویژگی</h4>
          <Button
            onClick={handleNewFeature}
            type="button"
            color="primary"
            text="بازگشت"
          />
        </div>
        <Formik
          enableReinitialize
          initialValues={{
            title: feature?.title || "",
            value: feature?.value || "",
          }}
          validationSchema={featureValidation}
          onSubmit={formHandler}
        >
          {(formik) => (
            <Form>
              <div className="grid gap-6 my-4 md:grid-cols-2">
                <Input
                  name={"title"}
                  placeholder="عنوان"
                  label="عنوان"
                  type="text"
                />
                <Input
                  name={"value"}
                  placeholder="مقدار"
                  label="مقدار"
                  type="text"
                />
              </div>
              <div className="mt-2 flex gap-x-3">
                {feature && (
                  <Button
                    type="button"
                    onClick={() => setFeature(null)}
                    text={"کنسل"}
                    color={"danger"}
                  />
                )}
                <Button text={feature ? "ویرایش" : "افزون"} color={"primary"} />
              </div>
            </Form>
          )}
        </Formik>

        <Table
          columns={featuresColumns}
          rows={features}
          // onEdit={onEdit}
          onDelete={onDelete}
          // onCustomFunction={addVariations}
          // customFunctionName={"ویژگی"}
          notFoundMessage="شما هنوز هیچ ویژگی اضافه نکرده اید"
        />
      </div>
    </>
  );
});
export default ProductFeature;
